import { InvoiceColumn, InvoiceView } from "@common/types/views/invoiceViews";

export const SCHEDULE_TEMPLATE_SEARCH_PARAM = "scheduleTemplateId";

const SCHEDULE_HANDOFF_VARIANT = "schedule-handoff";

function isInjectedScheduleColumn(
    column: InvoiceView["columns"][number],
): boolean {
    return (
        column.id === InvoiceColumn.SCHEDULE &&
        column.options?.customVariants?.variant === SCHEDULE_HANDOFF_VARIANT
    );
}

/**
 * Arriving from the Apply drawer's "Add invoices" card, the Schedule column has
 * to be on screen whether or not the user's saved view carries it. The injected
 * column is marked so it can be dropped again the moment the view is edited,
 * rather than silently persisting into their saved layout.
 */
export function injectScheduleColumn(view: InvoiceView): InvoiceView {
    if (view.columns.some((column) => column.id === InvoiceColumn.SCHEDULE)) {
        return view;
    }
    const amountColumnIndex = view.columns.findIndex(
        (column) => column.id === InvoiceColumn.AMOUNT,
    );
    const insertAt =
        amountColumnIndex < 0 ? view.columns.length : amountColumnIndex + 1;
    return {
        ...view,
        columns: [
            ...view.columns.slice(0, insertAt),
            {
                id: InvoiceColumn.SCHEDULE,
                options: {
                    pin: "right",
                    customVariants: { variant: SCHEDULE_HANDOFF_VARIANT },
                },
            },
            ...view.columns.slice(insertAt),
        ],
    };
}

export function stripInjectedScheduleColumn(view: InvoiceView): InvoiceView {
    return {
        ...view,
        columns: view.columns.filter(
            (column) => !isInjectedScheduleColumn(column),
        ),
    };
}
